import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { i18n } from '@/i18n/config';
import type { AppLocale } from '@/i18n/supported-languages';

export type Locale = AppLocale;

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

/**
 * Locale store
 * Manages application language preference
 */
export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: 'en',
      setLocale: (locale) => {
        set({ locale });
        i18n.changeLanguage(locale);
      },
    }),
    {
      name: 'trove-locale-storage',
      onRehydrateStorage: () => (state) => {
        if (state?.locale) {
          i18n.changeLanguage(state.locale);
        }
      },
    }
  )
);

